import React, { useMemo } from 'react'
import { useStateValue } from './state'

export const PillsContainer = () => {
  const [currentState] = useStateValue()
  const findFilters = useMemo(() => {
    return filterType => {
      const filterMap = new Map(
        currentState[filterType].map(item => [item[0], item])
      )
      return currentState.filters[filterType]
        .filter(id => filterMap.has(id))
        .map(id => filterMap.get(id))
    }
  }, [
    currentState.filters,
    currentState.chapters,
    currentState.tags,
    currentState.colors,
  ])

  return (
    <div className="mx-1 mb-1">
      {['chapters', 'colors', 'tags'].flatMap(filterType =>
        findFilters(filterType).map(option => (
          <FilterPill
            filterType={filterType}
            key={`${filterType}-${option[0]}`}
            id={option[0]}
            value={option[1]}
          />
        ))
      )}
    </div>
  )
}

const FilterPill = ({ filterType, id, value }) => {
  const [currentState, dispatch] = useStateValue()

  const handleRemove = () => {
    const currentValues = currentState.filters[filterType]
    const updatedValues = currentValues.filter(item => item !== id)
    dispatch({
      type: 'updateFilters',
      payload: { ...currentState.filters, [filterType]: updatedValues },
    })
  }

  return (
    <span
      className="d-inline-flex align-items-center mr-1 mt-1"
      style={styles.pill}
    >
      {value}
      <button
        onClick={handleRemove}
        className="border-0 p-0 cursor-pointer"
        style={styles.pillRemoveButton}
      >
        ×
      </button>
    </span>
  )
}

const styles = {
  pill: {
    gap: '6px',
    padding: '4px 10px',
    backgroundColor: '#e5e7eb',
    borderRadius: '16px',
    fontSize: '14px',
    color: '#374151',
  },
  pillRemoveButton: {
    background: 'none',
    fontSize: '16px',
    color: '#6b7280',
    lineHeight: '1',
  },
}
